import React, { useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import { RoutePath } from "../../../utility/Constant";
import { MdDeleteForever } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

function NewsAndEventsCard({ project, user, handleSingleDelete }) {
  const { aboutUsNews, aboutUsNewsAdd } = RoutePath;
  const [showMore, setShowMore] = useState(false);
  const [showMoreTitle, setShowMoreTitle] = useState(false);
  const [visibility, setVisibility] = useState(true);

  const handleDelete = async () => {
    const res = await handleSingleDelete(project._id);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  };
  const hasCoverImage = project?.banner_image?.url != "undefined" && (project?.banner_image?.url)?.trim().length > 0
  console.log(project?.title);
  console.log(project?.banner_image?.url);
  console.log(hasCoverImage);

  return (
    <>
      {visibility ? (
        <div className="group relative border flex flex-col overflow-hidden shadow-lg rounded-lg h-full bg-white">
          {project ? (
            <div className="flex flex-col justify-between h-full">
              {/* Image */}
              <figure>
                <img
                  src={`${process.env.REACT_APP_API_URL}images/${hasCoverImage ? project?.banner_image?.url : "newsDefaultImage.webp"}`}
                  alt={project.title + " Image"}
                  className="h-[120px] md:h-[180px] object-cover w-full"
                />
              </figure>

              {/* Content + Buttons */}
              <div className="p-4 flex flex-col justify-between gap-3 flex-grow">
                {/* Title, Date, Description */}
                <div>
                  <span className="text-sm font-medium text-gray-900">
                    <span className="font-semibold">Date: </span>
                    {project?.date}
                  </span>
                  <h2 className="mb-2 break-words md:text-lg font-semibold">
                    {project?.title?.length > 20 && !showMoreTitle ? (
                      <>
                        {project?.title?.substring(0, 25)}
                        <button
                          onClick={() => setShowMoreTitle(true)}
                          className="text-red-600 hover:text-[#DB0029] ml-1"
                        >
                          ...
                        </button>
                      </>
                    ) : (
                      <>
                        {project?.title}
                        {project?.title?.length > 20 && (
                          <button
                            onClick={() => setShowMoreTitle(false)}
                            className="text-red-600 hover:text-[#DB0029] ml-2 text-sm"
                          >
                            Show less
                          </button>
                        )}
                      </>
                    )}
                  </h2>

                  <p className="hidden md:block break-words text-gray-600">
                    {showMore
                      ? project?.short_description
                      : `${project?.short_description?.substring(0, 100)}`}
                  </p>
                  <p className="block md:hidden break-words text-gray-600">
                    {showMore
                      ? project?.short_description
                      : `${project?.short_description?.substring(0, 50)}`}
                  </p>
                </div>

                {/* Buttons Row */}
                <div className="flex items-center justify-between border-t pt-3 mt-3">
                  <button
                    onClick={() => setShowMore((old) => !old)}
                    className="text-sm text-red-600 hover:text-[#DB0029]"
                  >
                    {project?.para1?.length > 99 &&
                      (showMore ? "Show less" : "Show more")}
                  </button>
                  <div className="flex gap-2 text-sm md:text-base">
                    <Link
                      to={`/${aboutUsNews}/${project?._id}`}
                      className="btn btn-outline btn-xs text-blue-500 hover:text-blue-700 transition duration-150 rounded-lg"
                    >
                      <FaRegEdit size={20} />
                    </Link>
                    {user === "admin" && (
                      <button
                        id={project._id}
                        onClick={handleDelete}
                        className="btn btn-outline btn-xs text-red-500 px-3 hover:text-red-700 transition duration-150 rounded-lg"
                      >
                        <MdDeleteForever size={23} />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Link
              to={`/${aboutUsNewsAdd}`}
              className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full"
            >
              <p className="text-8xl group-hover:text-[#DB0029]">
                <AiFillFileAdd />
              </p>
            </Link>
          )}
        </div>
      ) : null}
    </>
  );
}

export default NewsAndEventsCard;
